import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Popup from 'reactjs-popup';
import { useWindowSize } from '../Common/CommonHooks';

const LoginPassKey = ({ showPassKeyRegConsent, showPassKeyRegSuccess, handleNext, handleRegSuccess }) => {
    const { t, i18n } = useTranslation();

    const { isMobileSize } = useWindowSize();
    let mobileStyle = isMobileSize ? 'is-mobile' : 'is-desktop';
    useEffect(() => {
        if (isMobileSize) {
            mobileStyle = 'is-mobile'
        } else {
            mobileStyle = 'is-desktop';
        }
    }, [isMobileSize]);

    const handleClickClose = () => {

        handleNext(false);
    }

    const handleBindPassKey = () => {
        handleNext(true);
    }

    const handleRegOK = () => {
        handleRegSuccess();
    }

    return (
        <>
            {showPassKeyRegConsent && (
                <Popup open={true} closeOnDocumentClick={false} className={`errorpopup ${mobileStyle}`} onClose={handleClickClose}>
                    <div className="errorpopup-container">
                        <div className="errorpopup-title">Passkey Register</div>
                        <div className="errorpopup-message">Do you want to register the passkey?</div>
                        <div className={`button-box loginerrorpopup-btn-grp`}>
                            <div className='row2'>
                                <div className="errorpopup-close" onClick={handleClickClose}>No</div>
                                <div className="errorpopup-unlock cta_yellow" onClick={handleBindPassKey}>Yes</div>
                            </div>
                        </div>
                    </div>
                </Popup>
            )}
            {showPassKeyRegSuccess && (
                <Popup open={true} closeOnDocumentClick={false} className={`errorpopup ${mobileStyle}`}>
                    <div className="errorpopup-container">
                        <div className="errorpopup-title">Passkey Register</div>
                        <div className="errorpopup-message">Passkey was saved successfully.</div>
                        <div className={`button-box loginerrorpopup-btn-grp`}>
                            <div className='row2'>
                                <div className="errorpopup-unlock cta_yellow" onClick={handleRegOK}>OK</div>
                            </div>
                        </div>
                    </div>
                </Popup>
            )}
        </>
        // ,

    )
}

export default LoginPassKey;